export enum InformationType {
  Help = 'Help',
  Information = 'Information',
  Promotion = 'Promotion',
  User = 'User',
  Contract = 'Contract',
  Brf = 'Brf',
  Exergi = 'Exergi',
  Invoice = 'Invoice',
  Error = 'Error',
  Company = 'Company',
  Ok = 'Ok',
  Heart = 'Heart',
  Contact = 'Contact',
  ContactInformation = 'ContactInformation',
  CustomerSupport = 'CustomerSupport',
  Cold = 'Cold',
  Environment = 'Environment',
  Location = 'Location',
  Waste = 'Waste',
  Private = 'Private',
  Stockholm = 'Stockholm',
  Phone = 'Phone',
  Hot = 'Hot',
  Intelligy = 'Intelligy'
}
